import { render, staticRenderFns } from "./MediaSettingsTabs.vue?vue&type=template&id=e5b90072&scoped=true"
import script from "./MediaSettingsTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./MediaSettingsTabs.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MediaSettingsTabs.vue?vue&type=style&index=0&id=e5b90072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b90072",
  null
  
)

export default component.exports